export default __webpack_public_path__ + "static/media/arrow-right.f943e970.svg";